import classes from './Features.module.scss';
import Image from 'next/image';
import Markdown from 'markdown-to-jsx';
import BadgeList from '../../molecules/badgeList/BadgeList';
import ImageList from '../../molecules/imageList/ImageList';

export default function Features(props) {
    if (!props) return null;

    const {
        image,
        title,
        copy,
        special_features,
        card_theme,
        app_list,
        background_image,
        tags_title
    } = props[0];

    return (
        <div
            className={`${classes.oFeaturesSectionBlock} ${
                classes[`image-${card_theme.image_position}`]
            } ${classes[`theme-${card_theme.region_color}`]}`}
        >
            <div className={`${classes.oContainer} container`}>
                <div className={`${classes.oBlockWrapper} row`}>
                    <div className={`${classes.oImageBlock}`}>
                        <figure className={classes.mImage}>
                            <Image
                                src={image?.data?.attributes.url}
                                alt={image?.data?.attributes.title}
                                width={image?.data?.attributes.width}
                                height={image?.data?.attributes.height}
                                className={classes.aImage}
                                aria-hidden="true"
                                layout="responsive"
                            />
                        </figure>
                    </div>
                    <div className={`${classes.oTextBlock} fontRTL`}>
                        <h3 className={`${classes.aTitle} fnt30f`}>{title}</h3>
                        <Markdown
                            className={`${classes.aText} ${classes.aDescriptionText} fnt18l fnt-sb`}
                        >
                            {copy}
                        </Markdown>
                    </div>
                    <div className={`${classes.oFeaturesBlock}`}>
                        <ImageList data={app_list} />
                        <BadgeList title={tags_title} data={special_features} />
                    </div>
                </div>
            </div>
            <div
                className={`${classes.oBackgroundBlock} ${
                    classes[`theme-${card_theme.region_color}`]
                }`}
            >
                <Image
                    src={background_image?.data?.attributes.url}
                    alt={background_image?.data?.attributes.title}
                    width={background_image?.data?.attributes.width}
                    height={background_image?.data?.attributes.height}
                    className={classes.aImage}
                    aria-hidden="true"
                    layout="responsive"
                />
            </div>
        </div>
    );
}
